import React, { Component } from "react";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import { withTranslation, Trans } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import ApiServices from "../../api/api";
import TextField from "@material-ui/core/TextField";
import Services from "../../api/api";
import swal from "sweetalert";
import { gaLogEvent } from "../../helpers/analytics";


class EmergencyContacts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userDetails: [],
      name: '',
      number: ''
    };
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeNumber = this.handleChangeNumber.bind(this);
  }
  componentDidMount() {
    gaLogEvent("Settings Emerg Contact", '', '');
    
  }

  handleChangeName(event) {
    // console.log(event)
    this.setState({
      name: event.target.value,
    });
  }
  handleChangeNumber(event) {
    // console.log(event)
    this.setState({
      number: event.target.value,
    });
  }

  handleSubmit = (event) => {
    var self = this;
    event.preventDefault();

    this.setState({ isLoading: true });

    var param = {
      "emergencyContacts": [
      {
      "contactNumber": this.state.number,
      "relation": this.state.name
      }
      ],
      "userId": JSON.parse(localStorage.getItem("obj")).userId
    };

    console.log("handleSubmit>>", param, JSON.stringify(param));
    var alpha = /^[a-zA-Z]+$/;
    var num = /^(0|91)?[7-9][0-9]{9}$/;
    if((this.state.number != "" && this.state.name == "")||(this.state.number == "" && this.state.name != "")){
      swal({
        title: "Please enter all the fields before submitting",
        icon: "warning",
        button: "Ok",
      })
    }else if(!this.state.number.match(num)){
      swal({
        title: "Please enter a valid phone number",
        icon: "warning",
        button: "Ok",
      })
    }else if(this.state.name.length < 3 || !this.state.name.match(alpha)){
      swal({
        title: "Name should be greater than 3 alphabets",
        icon: "warning",
        button: "Ok",
      })
    }else if(param.contactNumber != "" && param.relation != "" ) {
      Services.saveEmergencyContacts(param).then((res) => {
        console.log("addApplicant>>", res);
        if (res.data.status == 0) {
          console.log("successfully saved SOS contact")
          
          swal({
            text: "contact saved successfully",
            icon: "success",
            button: "ok",
          }).then((val) => {
              self.props.history.push("/layout");
          });
        }
  
      });
    } else {
      swal({
        title: "Please enter the contact number and name",
        icon: "warning",
        button: "Ok",
      })
    }
   
  };


  render() {
    const { t } = this.props;
    return (
      <form
        id="chat-profile"
        onSubmit={this.handleSubmit}
      >

        <Grid container spacing={3} className="gridcontainer">
          <Grid item xs={12} className="profileformholder">
            <TextField
              id="standard-helperText"
              label={t("Nickname")}
              onChange={this.handleChangeName}
            />
          </Grid>
          <Grid item xs={12} className="profileformholder">
            <TextField
              id="standard-helperText"
              label={t("Contact number")}
              type="number"
              onChange={this.handleChangeNumber}
            />
          </Grid>
          <Grid item xs={12} className="profileformholder">
            <div className="text-center">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disableElevation
                className="profilesubmitbtn"
              >
                {t('submit')}
            </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const transEmergencyContacts = withTranslation()(EmergencyContacts);
const themeEmergencyContacts = withTheme(transEmergencyContacts);
const routeEmergencyContacts = withRouter(themeEmergencyContacts);
export default connect(mapStateToProps, {})(routeEmergencyContacts);
